import React from "react";
import QAListItem from "./QAListItem";
import * as Styled from "../misc/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { Scrollbars } from "react-custom-scrollbars";

const QAList = ({ data, toggle }) => {
  return (
    <Styled.QAListContainer>
      <div className="qa__toggle">
        <FontAwesomeIcon icon={faTimes} onClick={toggle} />
      </div>
      <h4 className="qa__header">Vanliga frågor</h4>
      <Scrollbars
        autoHeightMax={'100%'}
      >
        <div className="qa__list">
          {data.map((o, i) => (
            <QAListItem key={i} {...o} />
          ))}
        </div>
      </Scrollbars>
    </Styled.QAListContainer>
  );
};

export default QAList;



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/components/QAList.js